import { FC } from "react";

import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  useMultiStyleConfig,
  PopoverProps,
} from "@chakra-ui/react";

import { IconButton } from "@components/buttons";
import Icon from "@components/Icon";
import { TCustomIconProps } from "@components/Icon/types";

type TIconDropdownProps = Pick<TCustomIconProps, "icon"> &
  PopoverProps & {
    isOpen?: boolean;
    isDisabled?: boolean;
    title?: string;
    onToggleOpen?: (open: boolean) => void;
    children?: any;
  };

const IconDropdown: FC<TIconDropdownProps> = ({ isOpen, isDisabled, onToggleOpen, children, title, icon, ...rest }) => {
  const styles = useMultiStyleConfig("Common", {});

  return (
    <Popover isOpen={isOpen} {...rest}>
      <PopoverTrigger>
        <div>
          <IconButton
            variant="transparent"
            icon={<Icon icon={icon} size="1.625rem" />}
            onClick={() => onToggleOpen?.(!isOpen)}
            isDisabled={isDisabled}
            title={title}
          />
        </div>
      </PopoverTrigger>
      <PopoverContent sx={styles.iconDropdown}>
        <PopoverArrow />
        <PopoverBody sx={styles.iconDropdownContent}>{children}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
export default IconDropdown;
